<div soho-busyindicator
     [style.height]="'100%'"
     [text]="' '"
     [blockUI]="true"
     [displayDelay]="20"
     [transparentOverlay]="true"
>
    <div [@panelDisplay]="showingOperatorBuilder ? 'hidden' : 'visible'">
        <div class="search-criteria-container" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
            <div class="field scope-criteria">
                <label soho-label for="item-desc">{{ 'FieldPicker_FieldNameLabel' | translate }}</label>
                <input
                    id="item-desc"
                    data-automation-id="lm-field-picker-field-name"
                    [(ngModel)]="searchOptions.nameValue"
                    (keydown.enter)="onSearchNameEnter($event)"
                    soho-field-filter
                    [fieldDropdownDataSet]="fieldNameComparators"
                    (filtered)="onFieldNameComparatorChange($event)"
                />
            </div>
            <div *ngIf="this.options.view !== 'Measures' && this.options.view !== 'Dimensions' && this.options.view !== 'DimensionsWithAttributes'" class="field scope-criteria">
                <label soho-label for="relatedBusinessClassFilter">{{ 'FieldPicker_BusinessClassScopeLabel' | translate }}</label>
                <select
                        id="relatedBusinessClassFilter"
                        data-automation-id="lm-field-picker-fields-from"
                        soho-dropdown
                        soho-tooltip
                        title="{{ 'FieldPicker_BusinessClassScopeTooltip' | translate }}"
                        style="width: 200px;"
                        [source]="businessClassSource"
                        [(ngModel)]="relatedFieldFilter">
                    <option class="clear"></option>
                    <option *ngFor="let businessClass of businessClasses" [value]="businessClass">{{businessClass}}</option>
                </select>
            </div>
            <div *ngIf="this.options.view !== 'SimpleConditions' && this.options.view !== 'Measures' && this.options.view !== 'Dimensions' && this.options.view !== 'DimensionsWithAttributes'" class="field scope-criteria">
                <label soho-label for="fieldType">{{ 'FieldPicker_FieldTypeLabel' | translate }}</label>
                <select
                        soho-dropdown
                        [ngClass]="'dropdown-md'"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        noSearch
                        id="fieldType"
                        data-automation-id="lm-field-picker-field-type"
                        name="fieldType"
                        style="width: 200px;"
                        [(ngModel)]="includeOptions">
                    <option *ngFor="let option of fieldTypes"
                            [value]="option.value">{{option.label}}</option>
                </select>
            </div>
            <div  *ngIf="this.options.view !== 'Measures' && this.options.view !== 'Dimensions' && this.options.view !== 'DimensionsWithAttributes'" class="field scope-criteria">
                <label soho-label for="searchScope">{{ 'FieldPicker_SearchDepthLabel' | translate }}</label>
                <select
                        id="searchScope"
                        data-automation-id="lm-field-picker-search-scope"
                        soho-dropdown
                        style="width: 250px;"
                        [(ngModel)]="searchScope">
                    <option [value]="'normal'">{{ 'FieldPicker_SearchDepthNormalLabel' | translate }}</option>
                    <option [value]="'extended'">{{ 'FieldPicker_SearchDepthExtendedLabel' | translate }}</option>
                    <option [value]="'max'">{{ 'FieldPicker_SearchDepthMaxLabel' | translate }}</option>

                </select>
            </div>
        </div>
        <div>
            <div class="lm-search-button-container">
                <button id="fieldPickerSearchBtn" data-automation-id="lm-field-picker-search-button" soho-button="tertiary" class="btn-tertiary lm-run-search-button"
                        (click)="onSearchClicked($event)">{{ 'Search' | translate }}</button>
                <button id="fieldPickerClearBtn" data-automation-id="lm-field-picker-clear-button" soho-button="tertiary" class="btn-tertiary lm-clear-search-button"
                        (click)="onClearSearchClicked($event)">{{ 'Clear' | translate }}</button>
            </div>
            <lm-list-searchtags
                *ngIf="searchingFromHere"
                data-automation-id="lm-field-picker-focus-search-tags"
                automationIdPrefix="field-picker-focus"

                [showRefineAndClear]="false"
                [searchTags]="searchingFromHereTags"
                (searchTagRemoved)="onSearchTagRemoved($event)"
                [iconName]="searchingFromHereContext?.length > 1 ? 'left-arrow' : 'close'"
            ></lm-list-searchtags>
        </div>
        <lm-notification #lmNotificationComponent data-automation-id="lm-field-picker-notification" [notificationType]="'info'" (lmNotificationEvent) = "onNotificationEvent($event)"></lm-notification>
        <div class="row lm-field-picker-datagrid-container">
            <div soho-datagrid #SohoDataGrid
                 *ngIf="gridOptions"
                 data-automation-id="lm-field-picker-data-grid"
                 [gridOptions]="gridOptions"
                 [emptyMessage]="emptyMessage"
                 (expandrow)="onExpandRow($event)"
                 (collapserow)="onCollapseRow($event)"
                 (rowDoubleClicked)="onRowDoubleClicked($event)"
                 (rowClicked)="onRowSelected($event)"
            ></div>
        </div>
    </div>

    <ng-container id="operatorBuilderContainer">
        <div [@panelDisplay]="showingOperatorBuilder ? 'visible' : 'hidden'">
            <div class="operator-container">
                <ng-container *ngIf="options.view === 'Measures'">
                    <h1 data-automation-id="lm-field-picker-header" class="fieldset-title lm-header-3">{{ 'FieldPicker_periodOperator_label' | translate }}</h1>
                    <div class="operator-input-container" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
                        <div class="scope-criteria field">
                        <label soho-label for="periodCategory">{{ 'FieldPicker_periodOperatorCategory_label' | translate }}</label>
                        <select
                                id="periodCategory"
                                soho-dropdown
                                noSearch
                                name="periodCategory"
                                data-automation-id="lm-field-picker-period-category"
                                (change)="onOperatorChange('periodCategory')"
                                [(ngModel)]="fieldOperatorInfo.periodOperatorInfo.periodInfo.category"
                                [ngClass]="'dropdown-md'">
                            <option [value]="'period'">{{ 'FieldPicker_periodOption_label' | translate }}</option>
                            <option [value]="'periodRange'">{{ 'FieldPicker_periodRangeOption_label' | translate }}</option>
                            <option [value]="'beginning balance'">{{ 'FieldPicker_beginningBalanceOption_label' | translate }}</option>
                            <option [value]="'ending balance'">{{ 'FieldPicker_endingBalanceOption_label' | translate }}</option>
                            <option [value]="'beginning ytd balance'">{{ 'FieldPicker_ytdBeginningBalanceOption_label' | translate }}</option>
                            <option [value]="'ending ytd balance'">{{ 'FieldPicker_ytdEndingBalanceOption_label' | translate }}</option>
                        </select>
                        </div>
                    </div>
                    <div *ngIf="fieldOperatorInfo?.periodOperatorInfo?.periodInfo?.category !== 'allYears'" class="operator-input-container" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
                        <div class="scope-criteria field">
                            <label soho-label for="yearOperator">{{ 'FieldPicker_yearOperator_label' | translate }}</label>
                            <select
                                    id="yearOperator"
                                    soho-dropdown
                                    noSearch
                                    name="yearOperator"
                                    data-automation-id="lm-field-picker-period-year-operator"
                                    (change)="onOperatorChange('yearOperator')"
                                    [(ngModel)]="fieldOperatorInfo.periodOperatorInfo.yearInfo.yearOperator"
                                    [ngClass]="'dropdown-md'">
                                <option class="clear"></option>
                                <option [value]="'prior year'">{{ 'FieldPicker_priorOption_label' | translate }}</option>
                                <option [value]="'next year'">{{ 'FieldPicker_nextOption_label' | translate }}</option>
                            </select>
                        </div>
                        <div class="scope-criteria field">
                            <label soho-label for="year">{{ 'FieldPicker_yearShift_label' | translate }}</label>
                            <input
                                id="year"
                                soho-input
                                soho-mask [options]="{process: 'number' , patternOptions: {allowThousandsSeparator: false}}"
                                class="period-number"
                                disabled="{{!fieldOperatorInfo.periodOperatorInfo.yearInfo.yearOperator}}"
                                data-automation-id="lm-field-picker-period-year-shift"
                                [attr.maxlength]="2"
                                (change)="onOperatorChange('year')"
                                (keyup)="onOperatorChange('year')"
                                [(ngModel)]="fieldOperatorInfo.periodOperatorInfo.yearInfo.year"/>
                        </div>
                        <div class="scope-criteria field">
                            <label soho-label for="periodPriorNext">{{ 'ColumnEditorPeriodOperatorLabel' | translate }}</label>
                            <select
                                    id="periodPriorNext"
                                    soho-dropdown
                                    noSearch
                                    name="periodPriorNext"
                                    data-automation-id="lm-field-picker-period-period-prior-next"
                                    (change)="onOperatorChange('periodPriorNext')"
                                    [(ngModel)]="fieldOperatorInfo.periodOperatorInfo.periodInfo.priorNext"
                                    [ngClass]="'dropdown-md'">
                                <option class="clear"></option>
                                <option [value]="'prior'">{{ 'FieldPicker_priorOption_label' | translate }}</option>
                                <option [value]="'next'">{{ 'FieldPicker_nextOption_label' | translate }}</option>
                            </select>
                        </div>
                        <div class="scope-criteria field">
                            <label
                                    soho-label
                                    [required]="true"
                                    for="periodOperator">{{ 'FieldPicker_period_label' | translate }}</label>
                            <select
                                    id="periodOperator"
                                    soho-dropdown
                                    noSearch
                                    name="periodOperator"
                                    data-automation-id="lm-field-picker-period-operator"
                                    (change)="onOperatorChange('periodOperator')"
                                    [(ngModel)]="fieldOperatorInfo.periodOperatorInfo.periodInfo.periodOperator"
                                    [ngClass]="'dropdown-md'">
                                <option [value]="'period'">{{ 'FieldPicker_periodOption_label' | translate }}</option>
                                <option [value]="'week'">{{ 'FieldPicker_weekOption_label' | translate }}</option>
                                <option [value]="'month'">{{ 'FieldPicker_monthOption_label' | translate }}</option>
                                <option [value]="'quarter'">{{ 'FieldPicker_quarterOption_label' | translate }}</option>
                                <option [value]="'year'">{{ 'FieldPicker_yearOption_label' | translate }}</option>
                            </select>
                        </div>
                        <div class="scope-criteria field">
                            <label
                                    data-automation-id="lm-field-picker-period-from-label"
                                    soho-label
                                    [required]="fieldOperatorInfo?.periodOperatorInfo?.periodInfo?.category === 'periodRange'"
                                    for="periodFrom">{{periodLabel}}</label>
                            <input
                                    id="periodFrom"
                                    soho-input
                                    soho-mask [options]="{process: 'number' , patternOptions: {allowThousandsSeparator: false}}"
                                    class="period-number"
                                    data-automation-id="lm-field-picker-period-from"
                                    [attr.maxlength]="4"
                                    (change)="onOperatorChange('periodFrom')"
                                    (keyup)="onOperatorChange('periodFrom')"
                                    [(ngModel)]="fieldOperatorInfo.periodOperatorInfo.periodInfo.from"/>
                        </div>
                        <div *ngIf="fieldOperatorInfo?.periodOperatorInfo?.periodInfo?.category === 'periodRange'" class="scope-criteria field">
                            <label
                                    soho-label
                                    [required]="fieldOperatorInfo?.periodOperatorInfo?.periodInfo?.category === 'periodRange'"
                                    for="periodTo">{{ 'FieldPicker_thru_label' | translate }}</label>
                            <input
                                    id="periodTo"
                                    soho-input
                                    soho-mask [options]="{process: 'number' , patternOptions: {allowThousandsSeparator: false}}"
                                    class="period-number"
                                    data-automation-id="lm-field-picker-period-thru"
                                    [attr.maxlength]="2"
                                    (change)="onOperatorChange('periodTo')"
                                    (keyup)="onOperatorChange('periodTo')"
                                    [(ngModel)]="fieldOperatorInfo.periodOperatorInfo.periodInfo.to"/>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="options.view !== 'Measures'">
                    <h1 class="fieldset-title lm-header-3">{{ 'FieldPicker_AddOperatorLabel' | translate }}</h1>
                    <div class="operator-input-container" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
                        <ng-container *ngIf="fieldOperators?.length > 0" id="fieldOperatorContainer">
                            <div class="scope-criteria ">
                                <div class="field">
                                    <label soho-label for="fieldOperator">{{ 'FieldPicker_FieldOperatorLabel' | translate }}</label>
                                    <select
                                            id="fieldOperator"
                                            soho-dropdown
                                            noSearch
                                            name="fieldOperator"
                                            data-automation-id="lm-field-picker-field-operator"
                                            (change)="onOperatorChange('fieldOperator')"
                                            [(ngModel)]="fieldOperatorInfo.fieldOperator"
                                            [ngClass]="'dropdown-md'">
                                        <ng-container *ngFor="let option of fieldOperators">
                                            <optgroup *ngIf="option.children" [label]="option.label">
                                                <option *ngFor="let child of option.children"
                                                        [value]="child.value">{{child.label}}</option>
                                            </optgroup>
                                            <option *ngIf="!option.children" [value]="option.value">{{option.label}}</option>
                                        </ng-container>
                                    </select>
                                </div>
                            </div>
                        </ng-container>
                        <div *ngIf="typeOperators?.length > 0"  class="scope-criteria ">
                            <div class="field">
                                <label soho-label for="typeOperator">{{ 'FieldPicker_TypeOperatorLabel' | translate }}</label>
                                <select
                                        id="typeOperator"
                                        soho-dropdown
                                        noSearch
                                        name="typeOperator"
                                        data-automation-id="lm-field-picker-type-operator"
                                        (change)="onOperatorChange('typeOperator')"
                                        [ngClass]="'dropdown-md'"
                                        [(ngModel)]="fieldOperatorInfo.typeOperatorInfo.typeOperator">
                                    <ng-container *ngFor="let option of typeOperators">
                                        <optgroup *ngIf="option.children" [label]="option.label">
                                            <option *ngFor="let child of option.children"
                                                    [value]="child.value">{{child.label}}</option>
                                        </optgroup>
                                        <option *ngIf="!option.children" [value]="option.value">{{option.label}}</option>
                                    </ng-container>
                                </select>
                            </div>
                        </div>
                        <div class="scope-criteria ">
                            <!--                        <ng-container *ngIf="fieldOperatorInfo?.typeOperator === 'as of'"-->
                            <!--                                      id="typeOperatorAsOfDateContainer">-->
                            <!--                            <div class="field">-->
                            <!--                                <label [required]="true" soho-label for="asOfDate">As Of Date</label> &lt;!&ndash; TODO TrANSLATE &ndash;&gt;-->
                            <!--                                <input-->
                            <!--                                        [(ngModel)]="fieldOperatorInfo.asOfDate"-->
                            <!--                                        id="asOfDate"-->
                            <!--                                        soho-datepicker-->
                            <!--                                        (keyup)="onOperatorChange()"-->
                            <!--                                        (change)="onOperatorChange()"/>-->
                            <!--                            </div>-->
                            <!--                        </ng-container>-->
                            <!--                        <ng-container *ngIf="fieldOperatorInfo?.typeOperator === 'split'" id="typeOperatorSplitOnContainer">-->
                            <!--                            <div class="field">-->
                            <!--                                <label [required]="true" soho-label for="split">Split On</label>&lt;!&ndash; TODO TrANSLATE &ndash;&gt;-->
                            <!--                                <input maxlength="1" (paste)="onOperatorChange()" (keyup)="onOperatorChange()"-->
                            <!--                                       [(ngModel)]="fieldOperatorInfo.splitOn" id="split"/>-->
                            <!--                            </div>-->
                            <!--                        </ng-container>-->
                            <ng-container *ngIf="fieldOperatorInfo?.typeOperatorInfo?.typeOperator === 'using'" id="javaFormatContainer">
                                <div class="field">
                                    <label [required]="true" soho-label for="javaFormat">{{ 'FieldPicker_FormatLabel' | translate }}</label>
                                    <input
                                            id="javaFormat"
                                            data-automation-id="lm-field-picker-type-operator-java-format"
                                            (paste)="onOperatorChange('javaFormat')"
                                            (keyup)="onOperatorChange('javaFormat')"
                                            [(ngModel)]="fieldOperatorInfo.typeOperatorInfo.javaFormat"/>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="fieldOperatorInfo?.typeOperatorInfo?.typeOperator === 'timestamp format'
                                    || fieldOperatorInfo?.typeOperatorInfo?.typeOperator === 'date format'
                                    || fieldOperatorInfo?.typeOperatorInfo?.typeOperator === 'anniversary format'
                                    || fieldOperatorInfo?.typeOperatorInfo?.typeOperator === 'period format'"
                                          id="formatStyleContainer">
                                <div class="field">
                                    <label soho-label for="fieldOperator">{{ 'FieldPicker_FormatStyleLabel' | translate }}</label>
                                    <select
                                            id="formatStyle"
                                            soho-dropdown
                                            noSearch
                                            name="formatStyle"
                                            data-automation-id="lm-field-picker-type-operator-format-style"
                                            (change)="onOperatorChange('formatStyle')"
                                            [ngClass]="'dropdown-md'"
                                            [(ngModel)]="fieldOperatorInfo.typeOperatorInfo.formatStyle">
                                        <option *ngFor="let option of formatStyles"
                                                [value]="option.value">{{option.label}}</option>
                                    </select>
                                </div>
                            </ng-container>
                            <ng-container
                                    *ngIf="fieldOperatorInfo?.typeOperatorInfo?.typeOperator === 'date format' || fieldOperatorInfo?.typeOperatorInfo?.typeOperator === 'anniversary format'"
                                    id="withDayNameContainer">
                                <div class="field field-checkbox">
                                    <input
                                            id="withDayName"
                                            soho-checkbox
                                            type="checkbox"
                                            class="checkbox"
                                            data-automation-id="lm-field-picker-type-operator-with-day-name"
                                            (change)="onOperatorChange('withDayName')"
                                            [(ngModel)]="fieldOperatorInfo.typeOperatorInfo.withDayName">
                                    <label soho-label for="withDayName" [forCheckBox]="true">{{ 'FieldPicker_WithDayNameLabel' | translate }}</label>
                                </div>
                                <div class="field field-checkbox" style="padding-inline-start: 20px"><!-- TODO css change -->
                                    <input
                                            id="withShortDayName"
                                            soho-checkbox
                                            type="checkbox"
                                            class="checkbox"
                                            disabled="{{!fieldOperatorInfo.typeOperatorInfo.withDayName}}"
                                            data-automation-id="lm-field-picker-type-operator-with-short-day-name"
                                            (change)="onOperatorChange('withShortDayName')"
                                            [(ngModel)]="fieldOperatorInfo.typeOperatorInfo.withShortDayName">
                                    <label soho-label for="withShortDayName" [forCheckBox]="true">{{ 'FieldPicker_UseShortNameLabel' | translate }}</label>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>

                <div class="" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
                    <div class="field">
                        <label soho-label for="lplName">{{ 'FieldPicker_FieldPreviewLabel' | translate }}</label>
                        <p data-automation-id="lm-field-picker-preview-name" id="lplName" [ngClass]="{'form-layout-compact': useCompactFormLayout}"><b>{{lplName}}</b></p>
                    </div>
                    <div *ngIf="operatorExample" class="field">
                        <label soho-label for="lplName">{{ 'FieldPicker_OperatorExampleLabel' | translate }}</label>
                        <p data-automation-id="lm-field-picker-format-example" id="operatorExample" [ngClass]="{'form-layout-compact': useCompactFormLayout}"><b>{{operatorExample}}</b></p>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

</div>
